import React from 'react'
import { Button, message, Tooltip } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import remarkGfm from 'remark-gfm'
import { Message } from '../../../types/storage.type'
import { unified } from 'unified'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import rehypeStringify from 'rehype-stringify'

interface CopyAssistantMessageProps {
  messageData: Message;
}

const CopyAssistantMessage: React.FC<CopyAssistantMessageProps> = ({ messageData }) => {
  const { content, role } = messageData

  if (role !== 'assistant' || typeof content !== 'string' || !content) {
    return null
  }

  const parseMarkdownToHtml = async (markdown: string) => {
    return await unified()
      .use(remarkParse)
      .use(remarkGfm)
      .use(remarkRehype)
      .use(rehypeStringify)
      .process(markdown)
      .then((file) => String(file))
  }

  const handleCopy = async () => {
    try {
      const htmlContent = await parseMarkdownToHtml(content)

      const textContent = content // Keep plain text version for text editors

      const blobHtml = new Blob([htmlContent], { type: 'text/html' })
      const blobText = new Blob([textContent], { type: 'text/plain' })

      const clipboardItem = new ClipboardItem({
        'text/html': blobHtml,
        'text/plain': blobText, // Allows pasting into plain text editors
      })

      await navigator.clipboard.write([clipboardItem])
      message.success('Copied to clipboard!')
    } catch (err) {
      message.error('Failed to copy.')
    }
  }

  return (
    <Tooltip title="Copy" placement="bottom">
      <Button type="text" icon={<CopyOutlined />} onClick={handleCopy} />
    </Tooltip>
  )
}

export default CopyAssistantMessage
